import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18n from '../../../i18n';

import { Currency } from '../Currency/Currency';
import { DataTable, DataTableCellAlignment } from '../DataTable/DataTable';
import { Icon } from '../Icon/Icon';
import { InlineQuantityControl } from '../InlineQuantityControl/InlineQuantityControl';
import { T } from '../T/T';
import { OrdersTableSummary } from './OrdersTableSummary';

import { ReactComponent as RemoveIcon } from 'assets/icons/main-16/trash-o--16.svg';

import { OrderResponse } from 'state/order/types';
import { TranslatableEnum } from '../T/GetTranslationForEnum';

export interface OrderDetailsProps {
    orderResponse: OrderResponse;
    values: any;
    handleChange: any;
    setFieldValue: any;
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    contents: {
        flex: 1,
    },
    icon: {
        fill: theme.palette.fixedDanger.main,
        marginTop: theme.spacing(0.5),
    },
}));

export const OrdersTableEdit: FC<OrderDetailsProps> = props => {
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    const data = props.orderResponse;
    return (
        <div className={classes.container}>
            <div className={classes.contents}>
                <DataTable
                    columns={[
                        {
                            key: 'name',
                            label: t('orders:columns.name'),
                        },
                        {
                            key: 'quantity',
                            label: '',
                            setMinWidth: true,
                            align: DataTableCellAlignment.RIGHT,
                            renderer: (v, row) => (
                                <InlineQuantityControl
                                    name={row.productId}
                                    value={props.values[row.productId]}
                                    onChange={props.handleChange}
                                />
                            ),
                        },
                        {
                            key: 'unitType',
                            label: '',
                            setMinWidth: true,
                            renderer: v => <T enum={TranslatableEnum.UNIT_TYPE}>{v}</T>,
                        },
                        {
                            key: 'totalPrice',
                            label: '',
                            setMinWidth: true,
                            align: DataTableCellAlignment.RIGHT,
                            renderer: (v, row) => (
                                <Currency bold={true}>
                                    {(row.totalPrice / row.quantity) * props.values[row.productId]}
                                </Currency>
                            ),
                        },
                        {
                            setMinWidth: true,
                            align: DataTableCellAlignment.RIGHT,
                            renderer: (_, row) => (
                                <div
                                    onClick={() => {
                                        props.setFieldValue(row.productId, 0);
                                    }}
                                >
                                    <Icon className={classes.icon} component={RemoveIcon} size={16} svgSize={16} />
                                </div>
                            ),
                        },
                    ]}
                    data={data && data.orderedProducts}
                />
            </div>
            {data && <OrdersTableSummary values={props.values} orderResponse={data} />}
        </div>
    );
};
